export const notFoundRoutes = [
  {
    path: '/404',
    name: 'not-found',
    component: () => import(/* webpackChunkName: "notifications" */ './NotFound.vue')
  },
  { path: '*', redirect: '/404' }
];
